<template>
  <div class="container">
    <not-found v-if="show404" />
    <div class="row" v-else-if="isLoading">
      <div class="col d-flex justify-content-center align-items-center">
        <loading />
      </div>
    </div>
    <div v-else>
      <h2 v-if="car.typeId && user.email">
        Przeglądasz listę wycen dla: <span class="bold">{{ car.name }}</span>
      </h2>
      <h2 v-else>
        Żeby przejrzeć wyceny musisz
        <span v-if="!car.typeId">wybrać auto </span
        ><span v-if="!car.typeId && !user">i </span
        ><span v-if="!user">się zalogować.</span>
      </h2>
      <div class="row mb-2" v-if="car.typeId">
        <div class="col">
          <input
            v-oninput="searchPhrase"
            class="form-control"
            name="search"
            type="search"
            placeholder="Wyszukaj po nazwie..."
          />
        </div>
      </div>
      <div class="mt-4 estimates-list">
        <ul class="list-group-flush">
          <li
            class="list-group-item work"
            v-for="(work, i) in filteredWorks"
            :key="i"
          >
            <router-link
              :to="{
                name: 'tec-estimate-detail',
                params: {
                  typeId: this.$route.params.typeId,
                  korId: work.korId,
                  itemMpId: work.itemMpId,
                },
              }"
              >{{ work.name }}</router-link
            >
          </li>
        </ul>
      </div>
      <mail-to-us
        bold-text="Brakuje twojej naprawy na liście?"
        small-text="Prześlij nam informacje lub kosztorys do weryfikacji"
        :type="FormTypes.ESTIMATES"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import NotFound from "@/views/NotFound";
import Loading from "@/components/Loading";
import MailToUs from "@/improvementForms/MailToUs";
import { FormTypes } from "@/improvementForms/formTypes";

const oninput = {
  created(el, binding) {
    el.oninput = () => {
      binding.instance.searchPhrase = el.value;
    };
  },
};

export default {
  components: { MailToUs, Loading, NotFound },
  mounted() {
    this.getEstimates();
  },
  data() {
    return {
      car: {},
      works: [],
      filteredWorks: [],
      show404: false,
      isLoading: true,
      searchPhrase: "",
      FormTypes,
    };
  },
  methods: {
    getEstimates() {
      const typeId = this.$route.params.typeId;
      if (typeId) {
        axios
          .get(`/api/tec/type_details/${typeId}/`)
          .then((response) => {
            this.car = response.data;
            axios
              .get(`/api/tec/works/${typeId}/`)
              .then((response) => {
                this.works = response.data.works;
                this.filteredWorks = this.works.sort((workA, workB) =>
                  workA.name < workB.name ? -1 : 1
                );
              })
              .finally(() => {
                this.isLoading = false;
                document.title = `Lista wycen dla ${this.car.name}`;
              });
          })
          .catch(() => {
            this.show404 = true;
            this.isLoading = false;
          });
      } else {
        const estimateListPath = this.$router
          .getRoutes()
          .find((route) => route.name === "tec-estimate-list-no-car")?.path;
        if (
          this.getSelectedCar?.typeId &&
          this.$route.path.startsWith(estimateListPath)
        ) {
          this.$router.push({
            name: "tec-estimate-list",
            params: { typeId: this.getSelectedCar.typeId },
          });
        }
        this.isLoading = false;
      }
    },
  },
  computed: {
    ...mapGetters("accounts", ["user"]),
    ...mapGetters("cars", ["getSelectedCar"]),
  },
  watch: {
    "$route.params.typeId"() {
      if (!this.$route.params.typeId) {
        this.works = [];
        this.filteredWorks = [];
      }
      this.isLoading = true;
      this.getEstimates();
    },
    getSelectedCar() {
      if (
        (!this.$route.params.typeId && this.getSelectedCar) ||
        (this.car.typeId &&
          this.getSelectedCar &&
          this.car.typeId !== this.getSelectedCar.typeId)
      ) {
        console.log("push");
        this.$router.push({
          name: "tec-estimate-list",
          params: { typeId: this.getSelectedCar.typeId },
        });
      }
    },
    searchPhrase() {
      this.filteredWorks = this.works
        .filter((work) =>
          work.name.toLowerCase().includes(this.searchPhrase.toLowerCase())
        )
        .sort((workA, workB) => (workA.name < workB.name ? -1 : 1));
    },
  },
  directives: {
    oninput,
  },
};
</script>
<style scoped>
.list-group-flush {
  padding-left: 0;
}

h2 {
  font-family: Roboto, sans-serif;
  font-weight: normal;
}

.bold {
  font-weight: bold;
}

.work a {
  color: black;
  text-decoration: none;
}
</style>
